import { Plugin } from "@aomao/engine";

export default class FsBtn extends Plugin {
  static get pluginName () {
    return "FsBtn";
  }
  fullClick = null;
  // 插件初始化
  init () {
    if(this.options.fullClick) {
      this.fullClick = this.options.fullClick;
    }
  }
  execute (message) {
    this.fullClick && this.fullClick();
  }
}



// WEBPACK FOOTER //
// ./src/components/mk-editor/fs_btn.js